import $ from 'jquery';
import Lenis from 'lenis'

document.querySelectorAll('img[title]').forEach(img => {
    img.dataset.oldtitle = img.getAttribute('title');
    img.setAttribute('title', '');
});

let lastIndent = null; // inizialmente null

// Initialize Lenis
const lenis = new Lenis({ autoRaf: true });
window.lenis = lenis;

function updateIndent() {
    const $desc = $('header .description');
    const winWidth = $(window).width();
    const baseIndent = 200;
    const maxWidth = 1770;
    const minIndent = 250; // indent minimo per schermi piccoli

    // Se la finestra è più larga di 1770px, calcola indent dinamicamente
    if (winWidth >= maxWidth) {
        const indent = baseIndent + ((1920 - winWidth) * 0.4);
        lastIndent = indent; // aggiorna l'ultimo indent valido
        $desc.css('text-indent', indent + 'px');
    } else {
        // Se non abbiamo mai calcolato un indent (primo caricamento sotto 1770px)
        if (lastIndent === null) {
            lastIndent = Math.max(minIndent, baseIndent + ((1920 - maxWidth) * 0.4));
        }
        // Mantieni l'ultimo valore calcolato
        $desc.css('text-indent', lastIndent + 'px');
    }
}

$(document).ready(function () {
    updateIndent();
    $(window).on('resize', updateIndent);

    // Search bar open/close -> stop/start Lenis (non invasivo)
    const bar = document.getElementById('search-bar');
    if (bar) {
        const updateLenisByVisibility = () => {
            if (!window.lenis) return; // guard se Lenis non è attivo (es. su carrello)
            const isHidden = bar.classList.contains('hidden') || bar.style.display === 'none';
            if (!isHidden) {
                // opened
                if (typeof window.lenis.stop === 'function') window.lenis.stop();
            } else {
                // closed
                if (typeof window.lenis.start === 'function') window.lenis.start();
            }
        };

        // initial check
        updateLenisByVisibility();

        // observe class changes and inline style changes
        const observer = new MutationObserver((mutations) => {
            let shouldCheck = false;
            for (const m of mutations) {
                if (m.type === 'attributes' && (m.attributeName === 'class' || m.attributeName === 'style')) {
                    shouldCheck = true;
                    break;
                }
            }
            if (shouldCheck) updateLenisByVisibility();
        });
        observer.observe(bar, { attributes: true, attributeFilter: ['class', 'style'] });

        // Also listen custom events if you dispatch any
        bar.addEventListener('search:open', updateLenisByVisibility);
        bar.addEventListener('search:close', updateLenisByVisibility);
    }
});


// Previeni resubmit al reload della pagina
if (window.history.replaceState) {
    window.history.replaceState(null, null, window.location.href);
}


// Gestisco la selezione degli autori se arrivo da una pagina diversa di Authors/Autori (Tipo da pagina prodotto)
document.addEventListener("DOMContentLoaded", function () {
    const authorItems = document.querySelectorAll(".author-item");
    const letterLinks = document.querySelectorAll(".letter-link");
    const letterTitles = document.querySelectorAll(".letter-title");

    function clearAuthorHighlights() {
        authorItems.forEach(a => a.classList.remove("highlight"));
    }

    function clearLetterHighlights() {
        letterTitles.forEach(l => l.classList.remove("highlight"));
    }

    // 🔹 Funzione per gestire offset dinamico
    function getScrollOffset() {
        return window.innerWidth < 768 ? 100 : 200;
    }

    function scrollWithOffset(el) {
        const offset = getScrollOffset();
        const elementTop = el.getBoundingClientRect().top + window.pageYOffset;
        const targetScroll = elementTop - offset;

        window.scrollTo({
            top: targetScroll,
            behavior: "smooth"
        });
    }

    function highlightAuthor(slug) {
        const authorEl = document.querySelector("#" + slug);
        if (authorEl) {
            clearAuthorHighlights();
            clearLetterHighlights();
            authorEl.classList.add("highlight");

            // highlight anche la lettera corrispondente
            const letterTitle = authorEl.closest(".letter-section")?.querySelector(".letter-title");
            if (letterTitle) letterTitle.classList.add("highlight");

            setTimeout(() => {
                scrollWithOffset(authorEl);
            }, 50);
        }
    }

    function highlightAuthorFromUrl() {
        const params = new URLSearchParams(window.location.search);
        const highlight = params.get("highlight");
        if (highlight) {
            highlightAuthor(highlight);
            return;
        }

        if (window.location.hash) {
            highlightAuthor(window.location.hash.replace("#", ""));
        }
    }

    // ✅ Esegui subito all'apertura
    highlightAuthorFromUrl();

    // ✅ Aggiorna quando cambia l'hash
    window.addEventListener("hashchange", highlightAuthorFromUrl);

    // 🔹 Click sulle lettere (sticky navigation)
    letterLinks.forEach(link => {
        link.addEventListener("click", function (e) {
            e.preventDefault();
            const targetId = this.getAttribute("href").replace("#", "");
            const targetSection = document.querySelector("#" + targetId);
            const targetLetter = targetSection?.querySelector(".letter-title");

            clearAuthorHighlights();
            clearLetterHighlights();

            if (targetLetter) targetLetter.classList.add("highlight");
            if (targetSection) scrollWithOffset(targetSection);

            history.replaceState(null, null, "#" + targetId);
        });
    });

    // 🔹 Click diretto sugli autori
    document.querySelectorAll("a[href^='#']").forEach(link => {
        link.addEventListener("click", function () {
            setTimeout(highlightAuthorFromUrl, 50);
        });
    });
});
